import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { TokenContext } from "./TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import ModalComponent from "./ModalComponent";
import StatoCivileSelect from "./StatoCivileSelect";
import Repo from "../Utility/Repo";

function ComponentiNucleoFamiliareComponent({
  componentiNucleoFamiliare,
  userId,
  titolo,
  cartellaSocialeId,
  nucleo,
}) {
  const apiToken = useContext(TokenContext);
  const [showModalAdd, setshowModalAdd] = useState(false);
  const [showModalModify, setshowModalModify] = useState(false);

  const [error, setError] = useState("");
  const initialFormData = {
    userId: userId,
    cartellaSocialeId: cartellaSocialeId,
    nome: "",
    cognome: "",
    codiceFiscale: "",
    dataNascita: "",
    luogoDiNascita: "",
    relazioneConAssistito: "",
    professione: "",
    redditoMensile: 0,
    indirizzo: "",
    cfParente: null,
    statoCivileValue: 0,
  };

  const [selectedStatoCivile, setSelectedStatoCivile] = useState(0);

  const handleStatoCivileChange = (event) => {
    setSelectedStatoCivile(Number(event.target.value));
  };

  const [formData, setFormData] = useState(initialFormData);

  const resetFormFields = () => {
    setFormData(initialFormData);
    setError("");
  };

  const toggleModalAdd = () => {
    resetFormFields();
    setshowModalAdd(!showModalAdd);
  };

  const toggleModalModify = () => {
    setshowModalModify(!showModalModify);
  };

  const handleCloseModalAdd = () => {
    setshowModalAdd(false);
    resetFormFields();
  };

  const handleCloseModalModify = () => {
    setshowModalModify(false);
    resetFormFields();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const showAdd = () => {
    resetFormFields();
    setshowModalAdd(true);
  };

  const handleDelete = (recordId) => {
    const confirmDelete = window.confirm(
      "Sei sicuro di voler eliminare questo record?"
    );

    if (confirmDelete) {
      Repo.ComponenteNucleoFamiliare(
        apiToken,
        nucleo,
        "Elimina",
        recordId,
        null
      )
        .then((response) => {
          if (response.status === 204) {
            window.location.reload();
          }
        })
        .catch((error) => {
          Repo.handleApiError(error, setError);
        });
    }
  };

  const handleModify = (recordId, ogg) => {
    setshowModalModify(true);
    formData.id = recordId;
    formData.userId = userId;
    formData.cartellaSocialeId = cartellaSocialeId;
    formData.nome = ogg.nome;
    formData.cognome = ogg.cognome;
    formData.codiceFiscale = ogg.codiceFiscale;
    formData.dataNascita = Repo.convertiFormatoData(ogg.dataNascita);
    formData.luogoDiNascita = ogg.luogoDiNascita;
    formData.relazioneConAssistito = ogg.relazioneConAssistito;
    formData.redditoMensile = ogg.redditoMensile;
    formData.indirizzo = ogg.indirizzo;
    formData.cfParente = ogg.cfParente;
    formData.statoCivileValue = ogg.statoCivileValue;
    setError("");
    bodyModify();
  };

  const handleSave = () => {
    const {
      userId,
      cartellaSocialeId,
      nome,
      cognome,
      codiceFiscale,
      dataNascita,
      luogoDiNascita,
      relazioneConAssistito,
      professione,
      redditoMensile,
      indirizzo,
      cfParente,
      statoCivileValue,
    } = formData;

    const redditoMensileValue =
      redditoMensile === "" ? 0 : parseFloat(redditoMensile);

    const data = {
      userId,
      cartellaSocialeId,
      nome,
      cognome,
      codiceFiscale,
      dataNascita,
      luogoDiNascita,
      relazioneConAssistito,
      professione,
      redditoMensile,
      indirizzo,
      cfParente,
      statoCivileValue,
    };

    Repo.ComponenteNucleoFamiliare(apiToken, nucleo, "Aggiungi", null, data)
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
      });

    resetFormFields();
  };

  const handleUpd = (id) => {
    const {
      userId,
      cartellaSocialeId,
      nome,
      cognome,
      codiceFiscale,
      dataNascita,
      luogoDiNascita,
      relazioneConAssistito,
      professione,
      redditoMensile,
      indirizzo,
      cfParente,
      statoCivileValue,
    } = formData;

    const data = {
      id: id,
      userId,
      cartellaSocialeId,
      nome,
      cognome,
      codiceFiscale,
      dataNascita,
      luogoDiNascita,
      relazioneConAssistito,
      professione,
      redditoMensile,
      indirizzo,
      cfParente,
      statoCivileValue,
    };
    Repo.ComponenteNucleoFamiliare(
      apiToken,
      nucleo,
      "Aggiorna",
      null,
      JSON.stringify(data)
    )
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        // Gestione dell'errore
        Repo.handleApiError(error, setError);
      });

    // resetFormFields();
  };

  const bodyAdd = () => {
    return (
      <>
        <div className="row mb-lg-3">Inserisci {titolo}</div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <input
                type="hidden"
                id="cartellaSocialeId"
                name="cartellaSocialeId"
                value={cartellaSocialeId}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="nome">Nome:</label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="cognome">Cognome:</label>
              <input
                type="text"
                id="cognome"
                name="cognome"
                value={formData.cognome}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="codiceFiscale">Codice Fiscale:</label>
              <input
                type="text"
                id="codiceFiscale"
                name="codiceFiscale"
                value={formData.codiceFiscale}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="dataNascita">Data di nascita:</label>
              <input
                type="date"
                id="dataNascita"
                name="dataNascita"
                value={formData.dataNascita}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="relazioneConAssistito">Ruolo familiare:</label>
              <input
                type="text"
                id="relazioneConAssistito"
                name="relazioneConAssistito"
                value={formData.relazioneConAssistito}
                onChange={handleChange}
              />
            </div>
            {nucleo == "P" && (
              <div>
                <label htmlFor="relazioneConAssistito">
                  CF dell'assistito:
                </label>
                <input
                  type="text"
                  id="cfParente"
                  name="cfParente"
                  value={formData.cfParente}
                  onChange={handleChange}
                />
              </div>
            )}

            {(nucleo == "P" || nucleo == "N") && (
              <div>
                <label htmlFor="indirizzo">indirizzo parente:</label>
                <input
                  type="text"
                  id="indirizzo"
                  name="indirizzo"
                  value={formData.indirizzo}
                  onChange={handleChange}
                />
              </div>
            )}

            <div className="pb-5">
              <label htmlFor="redditoMensile">Reddito mensile:</label>
              <input
                type="number"
                id="redditoMensile"
                name="redditoMensile"
                value={formData.redditoMensile}
                onChange={handleChange}
              />
            </div>
            <div className="select-wrapper pb-5">
              <label htmlFor="statoCivile">Stato civile:</label>
              <StatoCivileSelect
                onChangeSelect={handleStatoCivileChange}
                selectedValue={formData.statoCivileValue}
              />
            </div>
            <div className="d-flex justify-content-end">
              {!error && (
                <button
                  className="btn btn-primary btn-salva"
                  type="button"
                  onClick={() => handleSave()}
                >
                  Salva
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione:</b> {error}.
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const bodyModify = () => {
    return (
      <>
        <div className="row mb-lg-3">Modifica {titolo}</div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <input
                type="hidden"
                id="cartellaSocialeId"
                name="cartellaSocialeId"
                value={cartellaSocialeId}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="nome">Nome:</label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="cognome">Cognome:</label>
              <input
                type="text"
                id="cognome"
                name="cognome"
                value={formData.cognome}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="codiceFiscale">Codice Fiscale:</label>
              <input
                type="text"
                id="codiceFiscale"
                name="codiceFiscale"
                value={formData.codiceFiscale}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="dataNascita">Data di nascita:</label>
              <input
                type="date"
                id="dataNascita"
                name="dataNascita"
                value={Repo.convertiFormatoData(formData.dataNascita)}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="relazioneConAssistito">Ruolo familiare:</label>
              <input
                type="text"
                id="relazioneConAssistito"
                name="relazioneConAssistito"
                value={formData.relazioneConAssistito}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="redditoMensile">Reddito mensile:</label>
              <input
                type="number"
                id="redditoMensile"
                name="redditoMensile"
                value={formData.redditoMensile}
                onChange={handleChange}
              />
            </div>

            {nucleo == "P" && (
              <div>
                <label htmlFor="relazioneConAssistito">
                  CF dell'assistito:
                </label>
                <input
                  type="text"
                  id="cfParente"
                  name="cfParente"
                  value={formData.cfParente}
                  onChange={handleChange}
                />
              </div>
            )}
            {(nucleo == "P" || nucleo == "N") && (
              <div>
                <label htmlFor="indirizzo">indirizzo parente:</label>
                <input
                  type="text"
                  id="indirizzo"
                  name="indirizzo"
                  value={formData.indirizzo}
                  onChange={handleChange}
                />
              </div>
            )}

            <div>
              <label htmlFor="professione">Professione:</label>
              <input
                type="text"
                id="professione"
                name="professione"
                value={formData.professione}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="luogoDiNascita">luogoDiNascita parente:</label>
              <input
                type="text"
                id="luogoDiNascita"
                name="luogoDiNascita"
                value={formData.luogoDiNascita}
                onChange={handleChange}
              />
            </div>

            <div className="d-flex justify-content-end">
              {!error && (
                <button
                  className="btn btn-primary btn-salva"
                  type="button"
                  onClick={() => handleUpd(formData.id)}
                >
                  Modifica
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione:</b> {error}.
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="col-lg-12">
      <div className="card-wrapper card-space">
        <div className="card card-bg no-after card-big roundedCustom">
          <div className="etichetta">
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-plus`}></use>
            </svg>
            <span>
              {" "}
              <a
                className="text-decoration-none"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  showAdd();
                }}
              >
                Aggiungi
              </a>
            </span>
          </div>
          <div className="card-body" key="componentiNucleoFamiliare">
            <div className="row">
              <div className="col-lg-9"></div>
            </div>
            <h5>{titolo ?? ""}</h5>
            <div className="row mt-4">
              <div className="col-lg-2 text-center cella">
                <strong>Cognome e nome</strong>
              </div>
              <div className="col-lg-2 text-center cella">
                <strong>Reddito</strong>
              </div>
              <div className="col-lg-2 text-center cella">
                <strong> Data di Nascita</strong>
              </div>
              <div className="col-lg-3 text-center cella">
                <strong>Codice fiscale</strong>
              </div>
              <div className="col-lg-3 cella">
                <strong>Ruolo Familiare</strong>
              </div>
            </div>
            {componentiNucleoFamiliare &&
            componentiNucleoFamiliare.length > 0 ? (
              componentiNucleoFamiliare.map((componente, index) => (
                <div key={index}>
                  <div className="row mt-4">
                    <div className="col-lg-2 text-left cella">
                      {" "}
                      {componente.cognome} {componente.nome}
                    </div>
                    <div className="col-lg-2 text-right cella">
                      {componente.redditoMensile != null
                        ? componente.redditoMensile.toLocaleString("it-IT", {
                            style: "currency",
                            currency: "EUR",
                          })
                        : ""}
                    </div>
                    <div className="col-lg-2 text-right cella">
                      {componente.dataNascita}
                    </div>
                    <div className="col-lg-3 text-center cella">
                      {componente.codiceFiscale}
                    </div>
                    <div className="col-lg-2 text-left cella">
                      {componente.relazioneConAssistito}
                    </div>

                    <div className="col-lg-1 d-flex justify-content-end">
                      <button
                        className="btn btn-outline-primary p-1"
                        type="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Modifica"
                        onClick={() => handleModify(componente.id, componente)}
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-pencil`} />
                        </svg>
                      </button>

                      <button
                        className="btn btn-outline-danger p-1 ml-1"
                        type="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Elimina"
                        onClick={() => handleDelete(componente.id)}
                      >
                        <svg className="icon icon-danger">
                          <use href={`${iconSprite}#it-delete`} />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <hr />
                </div>
              ))
            ) : (
              <div className="alert alert-warning mt-3">
                Non ci sono componenti del nucleo familiare disponibili.
              </div>
            )}
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModalAdd}
        isOpen={showModalAdd}
        header="Aggiungi"
        body={bodyAdd()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalAdd}
      />

      <ModalComponent
        toggleModal={toggleModalModify}
        isOpen={showModalModify}
        header="Modifica"
        body={bodyModify()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalModify}
      />
    </div>
  );
}

export default ComponentiNucleoFamiliareComponent;
